import { Container, Row, Col } from "react-bootstrap";
import Link from "next/link";

const FooterBottomDetails = ({
	copyWriteText,
	termsLink,
	pricacyPolicyLink,
}) => {
	return (
		<Container>
			<Row>
				<Col md={6} xl={5} lg={5}>
					<p>{copyWriteText}</p>
				</Col>
				<Col md={6} xl={7} lg={7}>
					<ul>
						<li>
							<Link
								href={termsLink ? termsLink : "/terms-policy"}
							>
								Terms & Conditions
							</Link>
						</li>
						<li>
							<Link
								href={
									pricacyPolicyLink
										? pricacyPolicyLink
										: "/privacy-policy"
								}
							>
								Privacy Policy
							</Link>
						</li>
						<li>
							<Link href="/sitemap.xml">Site map</Link>
						</li>
						<li className="d-none">
							<Link href="/sitemap">Site map</Link>
						</li>
					</ul>
				</Col>
			</Row>
		</Container>
	);
};

export default FooterBottomDetails;

